import {StatisticsType, statisticsTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<StatisticsType>;

export const StatisticTypeSelect = (props: Props) => {
  const {options = statisticsTypes, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
